import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://admin.maliva.eu'
});

export default instance;
